import React, { useState } from "react";
import "./Skills.scss";
import { skillsSection } from "../../portfolio";

function Skills() {
  const [activeCategory, setActiveCategory] = useState(0);

  const categories = [
    {
      title: "Mobile Architecture",
      icon: "📱",
      color: "#0070f3",
      skills: [
        "React Native & TypeScript",
        "Modular, feature-based structure",
        "Native modules in Swift & Kotlin",
        "Performance profiling & optimisation"
      ]
    },
    {
      title: "State & Data",
      icon: "🧠",
      color: "#7c3aed",
      skills: [
        "Redux Toolkit & redux-persist",
        "React Query & Zustand",
        "Offline-first caching with MMKV",
        "REST API design & integration"
      ]
    },
    {
      title: "Real-time & Security",
      icon: "🔐",
      color: "#06b6d4",
      skills: [
        "Socket.IO & Microsoft SignalR",
        "SSL pinning & signed requests",
        "JWT auth with Keychain storage",
        "Push notifications & deep linking"
      ]
    },
    {
      title: "Release Engineering",
      icon: "🚀",
      color: "#10b981",
      skills: [
        "Fastlane & GitHub Actions",
        "Multi-flavour builds & code signing",
        "App Store & Play Store submissions",
        "Crashlytics & Sentry monitoring"
      ]
    }
  ];

  return (
    <div className="skills-main-container">
      {/* Section Header */}
      <div className="skills-header">
        <div className="header-badge">
          <span className="badge-icon">💻</span>
          <span className="badge-text">{skillsSection.title}</span>
        </div>
        
        <h1 className="skills-main-title">
          Apps that ship — and 
          <span className="title-highlight"> keep working</span>
        </h1>
        
        <p className="skills-main-subtitle">
          {skillsSection.subTitle}
        </p>
      </div>

      {/* Interactive Skills Grid */}
      <div className="skills-content">
        <div className="skills-categories-nav">
          {categories.map((category, index) => (
            <button
              key={index}
              className={`category-nav-item ${activeCategory === index ? 'active' : ''}`}
              onClick={() => setActiveCategory(index)}
              style={{ '--category-color': category.color }}
            >
              <span className="nav-icon">{category.icon}</span>
              <span className="nav-title">{category.title}</span>
            </button>
          ))}
        </div>

        <div className="skills-display-area">
          <div className="active-category-content">
            <div className="category-header">
              <div 
                className="category-icon-large"
                style={{ background: `linear-gradient(135deg, ${categories[activeCategory].color}, ${categories[activeCategory].color}dd)` }}
              >
                {categories[activeCategory].icon}
              </div>
              <h3 className="category-title">{categories[activeCategory].title}</h3>
            </div>
            
            <div className="category-skills">
              {categories[activeCategory].skills.map((skill, index) => (
                <div 
                  key={index} 
                  className="skill-item"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="skill-indicator"></div>
                  <span className="skill-text">{skill}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Visual Enhancement */}
          <div className="skills-visual">
            <div className="floating-elements">
              <div className="float-element element-1">⚛️</div>
              <div className="float-element element-2">📱</div>
              <div className="float-element element-3">🔧</div>
              <div className="float-element element-4">⚡</div>
            </div>
            
            <div className="code-snippet">
              <div className="code-header">
                <div className="code-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <span className="code-title">skills.js</span>
              </div>
              <div className="code-content">
                <div className="code-line">
                  <span className="code-keyword">const</span>
                  <span className="code-variable"> expertise</span>
                  <span className="code-operator"> = </span>
                  <span className="code-punctuation">{'{'}</span>
                </div>
                <div className="code-line">
                  <span className="code-property">  mobile</span>
                  <span className="code-punctuation">: </span>
                  <span className="code-string">'React Native'</span>
                  <span className="code-punctuation">,</span>
                </div>
                <div className="code-line">
                  <span className="code-property">  native</span>
                  <span className="code-punctuation">: </span>
                  <span className="code-string">'Swift + Kotlin'</span>
                  <span className="code-punctuation">,</span>
                </div>
                <div className="code-line">
                  <span className="code-property">  realtime</span>
                  <span className="code-punctuation">: </span>
                  <span className="code-string">'Socket.IO + SignalR'</span>
                </div>
                <div className="code-line">
                  <span className="code-punctuation">{'}'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Key Highlights */}
      <div className="skills-highlights">
        <div className="highlight-item">
          <div className="highlight-number">5+</div>
          <div className="highlight-label">Years Experience</div>
        </div>
        <div className="highlight-item">
          <div className="highlight-number">10+</div>
          <div className="highlight-label">Apps Shipped</div>
        </div>
        <div className="highlight-item">
          <div className="highlight-number">100K+</div>
          <div className="highlight-label">Users Reached</div>
        </div>
        <div className="highlight-item">
          <div className="highlight-number">7</div>
          <div className="highlight-label">Markets Served</div>
        </div>
      </div>
    </div>
  );
}

export default Skills;
